import type * as React from "react";
import { cn } from "cn";
import { Search } from "lucide-react";
import { Input } from "./ui/input";

export interface SearchFieldProps {
  value?: string;
  onChange?: (value: string) => void;
  /** @default "Search people, companies, events..." */
  placeholder?: string;
  /** Keyboard hint, e.g. "⌘ K". Pass null/"" to hide. */
  kbd?: string | null;
  /** Glassy translucent style for placement over the graph. @default false */
  glass?: boolean;
  /** @default "lg" */
  size?: "md" | "lg";
  style?: React.CSSProperties;
}


export function SearchField({value, onChange, placeholder = "Search people, companies, events...", kbd = "⌘ K",
  glass = false, size = "lg", style}: SearchFieldProps) {
  return <label style={style} className={cn(
    "flex min-w-0 flex-1 items-center gap-3 rounded-md border border-solid border-input px-4 text-muted-foreground shadow-xs transition-[box-shadow,border-color] focus-within:border-ring focus-within:ring-[3px] focus-within:ring-ring/50",
    size === "md" ? "h-[var(--control-md)]" : "h-[52px]",
    glass ? "bg-card/80 backdrop-blur-[var(--blur-panel)]" : "bg-card"
  )}>
    <Search className="size-5 shrink-0" aria-hidden="true" />
    <Input value={value} onChange={event => onChange?.(event.target.value)} placeholder={placeholder} aria-label="Search"
      className="h-full flex-1 rounded-none border-0 bg-transparent p-0 shadow-none focus-visible:ring-0" />
    {kbd && <kbd className="shrink-0 rounded-xs border border-solid border-[var(--border-subtle)] bg-secondary px-[7px] py-[3px] font-mono text-[length:var(--text-micro)] font-semibold text-[var(--text-secondary)]">{kbd}</kbd>}
  </label>;
}
